import { graphql } from "@/graphql/codegen/gql"

graphql(`
  mutation AddPurchasingCost($input: AddPurchasingCostInput!) {
    priceChange {
      addPurchasingCost(input: $input) {
        __typename
        ... on AddPurchasingCostSuccess {
          priceChangeSubmission {
            id
            changeId
            status
          }
        }
        ... on AddPurchasingCostFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation EditPurchasingCost($input: EditPurchasingCostInput!) {
    priceChange {
      editPurchasingCost(input: $input) {
        __typename
        ... on EditPurchasingCostSuccess {
          priceChangeSubmission {
            id
            changeId
            status
          }
        }
        ... on EditPurchasingCostFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
